import { render } from "./CopyRights.vue?vue&type=template&id=fb810fcc&scoped=true"
import script from "./CopyRights.vue?vue&type=script&lang=js"
export * from "./CopyRights.vue?vue&type=script&lang=js"

import "./CopyRights.vue?vue&type=style&index=0&id=fb810fcc&lang=css"
import "./CopyRights.vue?vue&type=style&index=1&id=fb810fcc&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb810fcc"]])

export default __exports__